(function () {
  'use strict';

  var PROMO_ENABLED = false; // Promotion on hold — flip to true to re-enable, no other changes needed.
  var GIFT_HANDLE = 'unisex-cult-superdry-tote'; // Cult Superdry Tote
  var THRESHOLD_CENTS = 200000; // R2000.00 (Shopify cart totals are in cents)
  var DISMISS_KEY = 'freeGiftPickerDismissed';

  var syncing = false;
  var variantsCache = null; // [{id, title, available, image}]
  var root = null; // widget container, created lazily

  // ---------- Cart helpers ----------

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function getGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === GIFT_HANDLE) return cart.items[i];
    }
    return null;
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
  }

  function removeVariant(variantId) {
    var updates = {};
    updates[variantId] = 0;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    });
  }

  function fetchGiftVariants() {
    if (variantsCache) return Promise.resolve(variantsCache);
    return fetch('/products/' + GIFT_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        var fallbackImage = product.images && product.images[0];
        variantsCache = (product.variants || []).map(function (v) {
          return {
            id: v.id,
            title: v.public_title || v.title,
            available: v.available,
            image: (v.featured_image && v.featured_image.src) || fallbackImage,
          };
        });
        return variantsCache;
      });
  }

  // ---------- Widget UI ----------

  function ensureStyles() {
    if (document.getElementById('free-gift-styles')) return;
    var style = document.createElement('style');
    style.id = 'free-gift-styles';
    style.textContent =
      '#free-gift-widget{position:fixed;right:16px;bottom:16px;z-index:9999;max-width:320px;' +
      'font-family:inherit;box-shadow:0 4px 20px rgba(0,0,0,.15);border-radius:10px;background:#fff;' +
      'color:#111;border:1px solid rgba(0,0,0,.08);overflow:hidden;transition:all .2s ease;}' +
      '#free-gift-widget[hidden]{display:none;}' +
      '.fg-card{padding:14px 16px;}' +
      '.fg-header{display:flex;align-items:flex-start;justify-content:space-between;gap:8px;margin-bottom:8px;}' +
      '.fg-title{font-size:14px;font-weight:600;line-height:1.3;margin:0;}' +
      '.fg-close{background:none;border:none;cursor:pointer;font-size:16px;line-height:1;padding:2px 4px;color:#666;}' +
      '.fg-close:hover{color:#111;}' +
      '.fg-sub{font-size:12px;color:#555;margin:0 0 10px;}' +
      '.fg-swatches{display:flex;gap:8px;flex-wrap:wrap;}' +
      '.fg-swatch{display:flex;flex-direction:column;align-items:center;gap:4px;width:78px;background:#fafafa;' +
      'border:1px solid rgba(0,0,0,.1);border-radius:8px;padding:6px;cursor:pointer;font-size:11px;color:#111;' +
      'text-align:center;transition:border-color .15s ease;}' +
      '.fg-swatch:hover{border-color:#111;}' +
      '.fg-swatch:disabled{opacity:.4;cursor:not-allowed;}' +
      '.fg-swatch img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:5px;display:block;background:#eee;}' +
      '.fg-pill{display:flex;align-items:center;gap:8px;padding:10px 14px;cursor:pointer;background:#111;color:#fff;font-size:13px;font-weight:600;}' +
      '.fg-pill span.fg-icon{font-size:16px;}' +
      '.fg-added{display:flex;align-items:center;gap:10px;padding:12px 14px;}' +
      '.fg-added img{width:40px;height:40px;object-fit:cover;border-radius:6px;flex:none;}' +
      '.fg-added-text{flex:1;font-size:12px;line-height:1.4;}' +
      '.fg-added-text strong{display:block;font-size:13px;}' +
      '.fg-link{background:none;border:none;padding:0;color:#111;text-decoration:underline;font-size:12px;cursor:pointer;}';
    document.head.appendChild(style);
  }

  function ensureRoot() {
    if (root) return root;
    root = document.createElement('div');
    root.id = 'free-gift-widget';
    root.hidden = true;
    document.body.appendChild(root);
    return root;
  }

  function hideWidget() {
    var el = ensureRoot();
    el.hidden = true;
    el.innerHTML = '';
  }

  function renderPicker(giftLine) {
    ensureStyles();
    var el = ensureRoot();
    el.hidden = false;

    fetchGiftVariants().then(function (variants) {
      var swatches = variants
        .map(function (v) {
          var disabled = !v.available;
          return (
            '<button class="fg-swatch" data-variant-id="' +
            v.id +
            '"' +
            (disabled ? ' disabled' : '') +
            '>' +
            '<img src="' +
            (v.image || '') +
            '" alt="' +
            v.title +
            '"/>' +
            '<span>' +
            v.title +
            (disabled ? ' (out of stock)' : '') +
            '</span>' +
            '</button>'
          );
        })
        .join('');

      el.innerHTML =
        '<div class="fg-card">' +
        '<div class="fg-header">' +
        '<p class="fg-title">' +
        (giftLine ? "You're getting a free Cult Tote 🎁" : "You've unlocked a free Cult Tote 🎁") +
        '</p>' +
        '<button class="fg-close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<p class="fg-sub">Pick your colour — it\'s free with your order.</p>' +
        '<div class="fg-swatches">' +
        swatches +
        '</div>' +
        '</div>';

      el.querySelector('.fg-close').addEventListener('click', function () {
        try {
          sessionStorage.setItem(DISMISS_KEY, '1');
        } catch (e) {}
        renderPill();
      });

      var buttons = el.querySelectorAll('.fg-swatch:not([disabled])');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function (evt) {
          var variantId = Number(evt.currentTarget.getAttribute('data-variant-id'));
          onPickColor(variantId, giftLine);
        });
      }
    });
  }

  function renderPill() {
    ensureStyles();
    var el = ensureRoot();
    el.hidden = false;
    el.innerHTML = '<div class="fg-pill"><span class="fg-icon">🎁</span> Free tote unlocked — pick your colour</div>';
    el.querySelector('.fg-pill').addEventListener('click', function () {
      try {
        sessionStorage.removeItem(DISMISS_KEY);
      } catch (e) {}
      renderPicker(null);
    });
  }

  function renderAdded(giftLine) {
    ensureStyles();
    var el = ensureRoot();
    el.hidden = false;
    el.innerHTML =
      '<div class="fg-added">' +
      '<img src="' +
      (giftLine.image || '') +
      '" alt=""/>' +
      '<div class="fg-added-text"><strong>Free tote added</strong>' +
      giftLine.variant_title +
      ' &middot; <button class="fg-link">Change colour</button></div>' +
      '<button class="fg-close" aria-label="Close">&times;</button>' +
      '</div>';
    el.querySelector('.fg-link').addEventListener('click', function () {
      renderPicker(giftLine);
    });
    el.querySelector('.fg-close').addEventListener('click', function () {
      try {
        sessionStorage.setItem(DISMISS_KEY, '1');
      } catch (e) {}
      hideWidget();
    });
  }

  // ---------- Actions ----------

  function onPickColor(variantId, existingGiftLine) {
    var chain = Promise.resolve();
    if (existingGiftLine && existingGiftLine.variant_id !== variantId) {
      chain = chain.then(function () {
        return removeVariant(existingGiftLine.variant_id);
      });
    }
    if (!existingGiftLine || existingGiftLine.variant_id !== variantId) {
      chain = chain.then(function () {
        return addVariant(variantId);
      });
    }
    chain
      .then(function () {
        try {
          sessionStorage.removeItem(DISMISS_KEY);
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('free-gift:added'));
        return sync(true);
      })
      .catch(function (err) {
        console.error('[free-gift] pick colour failed', err);
      });
  }

  // ---------- Sync ----------

  function sync(force) {
    if (syncing && !force) return;
    syncing = true;
    getCart()
      .then(function (cart) {
        var giftLine = getGiftLine(cart);

        if (!PROMO_ENABLED) {
          // Promotion is on hold — never prompt, and quietly clear out any gift
          // line left over from earlier testing.
          hideWidget();
          if (giftLine) {
            return removeVariant(giftLine.variant_id);
          }
          return;
        }

        var giftOriginalPrice = giftLine ? giftLine.original_line_price : 0;
        var base = typeof cart.original_total_price === 'number' ? cart.original_total_price : cart.total_price;
        var otherSubtotal = base - giftOriginalPrice;
        var qualifies = otherSubtotal >= THRESHOLD_CENTS;

        if (!qualifies) {
          if (giftLine) {
            // No longer qualifies — remove the gift and reset so the offer can trigger fresh next time.
            return removeVariant(giftLine.variant_id).then(function () {
              try {
                sessionStorage.removeItem(DISMISS_KEY);
              } catch (e) {}
              document.dispatchEvent(new CustomEvent('free-gift:removed'));
              hideWidget();
            });
          }
          hideWidget();
          return;
        }

        // Qualifies.
        if (giftLine) {
          renderAdded(giftLine);
          return;
        }

        var dismissed = false;
        try {
          dismissed = sessionStorage.getItem(DISMISS_KEY) === '1';
        } catch (e) {}

        if (dismissed) {
          renderPill();
        } else {
          renderPicker(null);
        }
      })
      .catch(function (err) {
        console.error('[free-gift] sync failed', err);
      })
      .finally(function () {
        syncing = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    sync();
  });

  // Theme-agnostic: re-sync after any cart-mutating request completes, regardless
  // of which component (cart drawer, quick add, product form) triggered it.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var result = originalFetch.apply(this, arguments);
    try {
      var target = arguments[0];
      var url = typeof target === 'string' ? target : (target && target.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        result.then(function (res) {
          setTimeout(function () {
            sync(true);
          }, 300);
          return res;
        });
      }
    } catch (e) {
      /* no-op */
    }
    return result;
  };
})();
